import React from 'react';
import SRC from '@Theme/images/new-layout.png';
import './image.css';

function _ImageTemp() {
  return (
    <div className="onsite-image-layout">
      <img src={SRC} width="100%" />
    </div>
  );
}

export { _ImageTemp };
